/**
 * This module was automatically generated by `ts-interface-builder`
 */
import * as t from "ts-interface-checker";
// tslint:disable:object-literal-key-quotes

export const SnapshotWindow = t.iface([], {
  "count": "number",
  "unit": t.union(t.lit("days"), t.lit("month"), t.lit("year")),
});

export const Product = t.iface([], {
  "name": "string",
  "features": "Features",
});

export const Features = t.iface([], {
  "vanityDomain": t.opt("boolean"),
  "workspaces": t.opt("boolean"),
  "maxSharesPerDoc": t.opt("number"),
  "maxSharesPerDocPerRole": t.opt(t.iface([], {
    [t.indexKey]: "number",
  })),
  "maxSharesPerWorkspace": t.opt("number"),
  "maxDocsPerOrg": t.opt("number"),
  "maxWorkspacesPerOrg": t.opt("number"),
  "maxUsersPerOrg": t.opt("number"),
  "readOnlyDocs": t.opt("boolean"),
  "snapshotWindow": t.opt("SnapshotWindow"),
  "baseMaxRowsPerDocument": t.opt("number"),
  "baseMaxApiUnitsPerDocumentPerDay": t.opt("number"),
  "baseMaxDataSizePerDocument": t.opt("number"),
  "baseMaxAttachmentsBytesPerDocument": t.opt("number"),
  "maxAttachmentsBytesPerOrg": t.opt("number"),
  "maxApiCallsPerOrgMonth": t.opt("number"),
  "gracePeriodDays": t.opt("number"),
  "noGraceBanner": t.opt("boolean"),
  "baseMaxAssistantCalls": t.opt("number"),
  "minimumUnits": t.opt("number"),
  "meteredSeats": t.opt("boolean"),
  "teamAuditLogs": t.opt("boolean"),
  "automations": t.opt("boolean"),
  "importFromGrist": t.opt("boolean"),
  "maxNewUserInvitesPerOrg": t.opt("number"),
  "installationEnabled": t.opt("boolean"),
  "installationFleet": t.opt("boolean"),
  "installationSeats": t.opt("number"),
  "installationReadOnly": t.opt("boolean"),
  "installationGracePeriodDays": t.opt("number"),
  "installationNoGraceBanner": t.opt("boolean"),
});

export const StripeMetaValues = t.iface([], {
  "isStandard": t.opt("boolean"),
  "gristProduct": t.opt("string"),
  "gristLimit": t.opt("string"),
  "family": t.opt("string"),
  "trialPeriodDays": t.opt("number"),
});

const exportedTypeSuite: t.ITypeSuite = {
  SnapshotWindow,
  Product,
  Features,
  StripeMetaValues,
};
export default exportedTypeSuite;
